import React from 'react';
import { useAnimateOnView } from '../../hooks/useIntersectionObserver';
import './CommunitySection.css';

const PHOTOS = [
  { src: '/assets/img/taller/taller1.webp', alt: 'Encuentro grupal de parejas en las oficinas de Conectemos Chile' },
  { src: '/assets/img/taller/taller3.webp', alt: 'Conversación entre asistentes durante un encuentro de Conectemos Chile' },
  { src: '/assets/img/taller/taller2.webp', alt: 'Facilitador guiando la conversación en un encuentro de Conectemos Chile' },
  { src: '/assets/img/taller/taller4.webp', alt: 'Grupo de parejas reunidas en un encuentro de Conectemos Chile' },
];

const CommunitySection: React.FC = () => {
  const [ref, shouldAnimate] = useAnimateOnView();

  return (
    <section
      ref={ref}
      className={`community-section section-padding${shouldAnimate ? ' loaded' : ''}`}
      id="comunidad-talleres"
    >
      <div className="container">
        <div className="cs-content">
          <div className="cs-text animate-in" style={{ '--delay': '0.1s' } as React.CSSProperties}>
            <span className="cs-eyebrow">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" />
                <path d="M16 12a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" />
                <path d="M2 20c.5-3.2 2.7-5 6-5s5.5 1.8 6 5" />
                <path d="M14 15.2c2.6.3 4.5 2 5 4.8" />
              </svg>
              Comunidad
            </span>
            <h2 className="section-title cs-title">
              <span>Un espacio para preguntarnos qué es ser pareja</span>
            </h2>
            <p className="cs-body">
              El 21 de marzo abrimos las puertas de la oficina para un encuentro distinto a la terapia: una
              tribuna abierta donde conversamos y reflexionamos juntos preguntas como <em>"¿qué significa ser
              pareja?"</em> — sin apuro, entre personas que están pensando lo mismo.
            </p>
            <p className="cs-body cs-body--teaser">
              El sábado 3 de octubre viene el próximo. Todavía no soltamos todo — pero si te gustan los libros
              de Walter Riso, vas a querer estar. Cupos limitados, con valor de entrada.
            </p>
            <a
              className="cs-cta"
              href="https://wa.me/56972783309?text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20encuentro%20del%203%20de%20octubre%20de%20Conectemos%20Chile"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Escribir por WhatsApp para más información del encuentro del 3 de octubre"
            >
              <i className="fab fa-whatsapp" aria-hidden="true"></i>
              Quiero más información del próximo encuentro
            </a>
          </div>

          <div className="cs-gallery animate-in" style={{ '--delay': '0.25s' } as React.CSSProperties} role="group" aria-label="Fotos de encuentros de Conectemos Chile">
            {PHOTOS.map((photo, index) => (
              <div key={photo.src} className={`cs-gallery__item cs-gallery__item--${index + 1}`}>
                <img src={photo.src} alt={photo.alt} loading="lazy" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommunitySection;
